import { format } from 'date-fns';
import { ja } from 'date-fns/locale';
import { Page } from 'framework7-react';
import { FC, useState } from 'react';
import Calendar, { CalendarProps } from 'react-calendar';
import { PopupTemplate } from '@/components/uiParts/Template/PopupTemplate/PopupTemplate';
import { DATE_MONTH_INCREMENTER } from '@/utils/date';

interface SelectCalendarProps extends CalendarProps {
  name: string;
  value: Date | null;
  onChange: (value: Date | null) => void;
}

type DateClass = { date: Date };

const formatDateWithDay = (date: Date) => {
  return format(date, 'yyyy年M月d日', { locale: ja });
};

export const SelectCalendar: FC<SelectCalendarProps> = (props) => {
  const { name, value, onChange, ...calendarProps } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentView, setCurrentView] = useState<
    'month' | 'year' | 'decade' | 'century' | null
  >(null);

  const clickDay = (value: Date) => {
    setIsModalOpen(false);
    onChange(value);
  };

  const prevLabel = currentView === 'year' ? '＜ 前年' : '＜ 前月';
  const nextLabel = currentView === 'year' ? '次年 ＞' : '次月 ＞';

  const valueFormat = value
    ? formatDateWithDay(new Date(value) || Date.now())
    : '';

  return (
    <>
      <div className="input-calendar" onClick={() => setIsModalOpen(true)}>
        <input type="text" name={name} value={valueFormat} readOnly />
      </div>

      <PopupTemplate
        id={`SelectCalendar-${name}`}
        title=""
        opened={isModalOpen}
        handleClose={() => setIsModalOpen(false)}
      >
        <Page name="birthdayCalendarPopUp">
          <Calendar
            prev2Label={null}
            next2Label={null}
            value={value || null}
            onClickDay={clickDay}
            minDetail={'year'}
            nextLabel={nextLabel}
            prevLabel={prevLabel}
            navigationLabel={({ date }: DateClass) => {
              const year = date.getFullYear();
              const month = date.getMonth() + DATE_MONTH_INCREMENTER;
              return `${year}年${month}月`;
            }}
            formatShortWeekday={(locale, date) => {
              const day = date.getDay();
              const weekday = ['日', '月', '火', '水', '木', '金', '土'];
              return weekday[day];
            }}
            onViewChange={({ view }) => setCurrentView(view)}
            formatDay={(_, date) => String(date.getDate())}
            {...calendarProps}
          />
        </Page>
      </PopupTemplate>
    </>
  );
};
